const MENTION_REGEX = /@([A-Za-z0-9._-]+)/g;
const ACTIVE_MENTION_REGEX = /(^|\s)@([A-Za-z0-9._-]*)$/;

const normalizeUsername = (username) => String(username || '').trim().replace(/^@/, '');

function extractActiveMention(text, caretPosition) {
    const value = String(text || '');
    const caret = Number.isFinite(caretPosition) ? caretPosition : value.length;
    const beforeCaret = value.slice(0, Math.max(0, Math.min(caret, value.length)));
    const match = beforeCaret.match(ACTIVE_MENTION_REGEX);

    if (!match) {
        return { active: false };
    }

    return {
        active: true,
        query: match[2] || '',
        start: match.index + (match[1] ? match[1].length : 0),
        end: beforeCaret.length
    };
}

function insertMention(text, range, username) {
    const value = String(text || '');
    const safeRange = range || { start: value.length, end: value.length };
    const mention = `@${normalizeUsername(username)}`;
    const nextText = `${value.slice(0, safeRange.start)}${mention} ${value.slice(safeRange.end)}`;

    return {
        text: nextText,
        caret: safeRange.start + mention.length + 1
    };
}

function splitCommentMentions(text, allowedMentions = []) {
    const value = String(text || '');
    const allowed = new Set((allowedMentions || []).map((mention) => normalizeUsername(mention).toLowerCase()).filter(Boolean));
    const parts = [];
    let lastIndex = 0;
    let match;

    MENTION_REGEX.lastIndex = 0;

    while ((match = MENTION_REGEX.exec(value)) !== null) {
        if (match.index > lastIndex) {
            parts.push({
                type: 'text',
                text: value.slice(lastIndex, match.index)
            });
        }

        const username = match[1];
        const isAllowed = allowed.has(username.toLowerCase());

        parts.push(isAllowed ? {
            type: 'mention',
            username,
            text: `@${username}`
        } : {
            type: 'text',
            text: `@${username}`
        });

        lastIndex = match.index + match[0].length;
    }

    if (lastIndex < value.length) {
        parts.push({
            type: 'text',
            text: value.slice(lastIndex)
        });
    }

    return parts.length > 0 ? parts : [{ type: 'text', text: value }];
}

module.exports = {
    MENTION_REGEX,
    extractActiveMention,
    insertMention,
    splitCommentMentions
};
